import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Margin, Series, Size } from "devextreme-react/chart";
import { useMemo } from "react";
import { useScreenSizeClass } from "../../hooks";
import { HomeReportCustomerTypeData } from "../../models";

export interface NewCustomerTypeProps {
    data?: HomeReportCustomerTypeData;
}

export default function NewCustomerType(props: NewCustomerTypeProps) {
    const dataSource = useMemo(() => {
        const list: any[] = [];
        const data = props.data;
        if (!data) { return []; }

        for (const key in data.newCounts) {
            list.push({
                source: key,
                count: data.newCounts[key]
            });
        }

        return list;
    }, [props]);

    const sizeClass = useScreenSizeClass();

    return (
        <PieChart
            palette={"Bright"}
            dataSource={dataSource}
            title={"新开户类型分布图"}
            resolveLabelOverlapping={"shift"}>
            <Series argumentField={"source"} valueField="count">
                <Label visible={true} customizeText={customizeText}>
                    <Connector visible={true} width={1} />
                </Label>
            </Series>
            <Margin bottom={20} />
            <Legend verticalAlignment="bottom" horizontalAlignment="center" />
            <Export enabled={true} />
            <Size width={sizeClass === "screen-x-small" ? 320 : 400} />
        </PieChart>
    )
}

function customizeText(arg: any) {
    return `${arg.valueText}（${arg.percentText}）`;
}